import React from 'react';    
import './FeaturedVideo.css';

// Replace with your desired YouTube video ID
const VIDEO_ID = 'CBpLRI16qQk'; // Removed the extra ? character

function FeaturedVideo() {
  return (
    <div className="video-container">
      <div className="featured-video-title">Featured Video</div>
      <div className="video-responsive-wrapper">
        <iframe
          src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&mute=1&rel=0`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; autoplay"
          allowFullScreen
          title="Featured YouTube Video"
          style={{ width: '100%', height: '100%' }}
        ></iframe>
      </div>
      <div className="youtube-button-container">
        <a
          href={`https://linktr.ee/C4Cookiie`}
          className="view-more-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit My Socials
        </a>
      </div>
    </div>
  );
}

export default FeaturedVideo;